/* ==========================================================================
   Quick view repair — 2026-10-05

   THE BUG
   The "Quick view" button on product cards (snippets/product-item.liquid)
   hands theme.js the plain product URL. theme.js fetches that page and looks
   inside it for the block marked data-section-type="product-quick-view".
   That block is only emitted by sections/main-product.liquid, and the default
   product template (templates/product.json) stopped using main-product when
   the product page was redesigned. So the block is never found, theme.js
   throws "Cannot read properties of null (reading 'getAttribute')", and the
   page just dims with nothing in the dialog.

   THE FIX
   templates/product.quick-view.json still renders main-product, so asking
   for the same URL with ?view=quick-view returns the block theme.js wants.
   This listener runs in the capture phase, before theme.js reads the button,
   and adds that parameter.

   The source fix is one attribute in snippets/product-item.liquid:
     data-product-url="{{ product.url }}?view=quick-view"
   It lives here instead because the theme API has no partial write and that
   snippet is 19KB. If the snippet is ever corrected, this still does nothing
   harmful: it skips URLs that already carry the parameter.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-secondary-action="open-quick-view"]') : null;
    if (!button) { return; }
    var url = button.getAttribute('data-product-url') || '';
    if (!url || url.indexOf('view=quick-view') !== -1) { return; }
    button.setAttribute('data-product-url', url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=quick-view');
  }, true);

  /* Two leftovers from the old product page that do not belong in a compact
     dialog: the "Our Clients" logo strip, and a hardcoded "Inc. Vat" label
     that repeats what the price already says ("£4.50 inc VAT Inc. Vat"). */
  var style = document.createElement('style');
  style.textContent =
    '[data-section-type="product-quick-view"] .featured-product > section.section{display:none}' +
    '[data-section-type="product-quick-view"] .product-form__info-content > span:not([class]){display:none}';
  document.head.appendChild(style);
})();
